import { useReducer } from "react";

import type { Reducer } from "react";

interface MenuState {
  list: { isOpen: boolean };
  insert: { isOpen: boolean };
  image: { isOpen: boolean };
}

type MenuAction =
  | {
      type: "open" | "close";
      name: keyof MenuState;
    }
  | {
      type: "close all";
    };

const menuReducer: Reducer<MenuState, MenuAction> = (state, action): MenuState => {
  switch (action.type) {
    case "open":
      return {
        ...state,
        [action.name]: { isOpen: true },
      };
    case "close":
      return { ...state, [action.name]: { isOpen: false } };
    case "close all":
      return Object.fromEntries(
        Object.entries(state).map(([name, menu]) => [name, { ...menu, isOpen: false }]),
        // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      ) as MenuState;
  }
  return state;
};

export interface MenuContext {
  state: MenuState;
  dispatch: React.Dispatch<MenuAction>;
  close: (name: keyof MenuState) => () => void;
  open: (name: keyof MenuState) => () => void;
}

export const useMenuReducer = (): MenuContext => {
  const [state, dispatch] = useReducer(menuReducer, {
    list: { isOpen: false },
    insert: { isOpen: false },
    image: { isOpen: false },
  });

  const close = (name: keyof MenuState) => () => dispatch({ type: "close", name });
  const open = (name: keyof MenuState) => () => {
    dispatch({ type: "close all" });
    dispatch({ type: "open", name });
  };

  return { state, dispatch, close, open };
};
